export default {"src":"/_next/static/media/vi.07f7deb0.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};